import React from 'react';
import { Flex } from 'grid-styled';
import styled from 'styled-components';

const Frame = styled.div`
    position: relative;
    flex: 1;
    height: 5px;
    border: 1px solid green;
    background: linear-gradient(to left, red, orange, yellow, green);
    background: linear-gradient(
        to right,
        #37ff13 0%,
        #37ff13 59%,
        #ffef2d 59%,
        #ffef2d 91%,
        #f00 91%,
        #f00 100%
    );
`;

const Overlay = styled.div`
    position: absolute;
    background-color: rgba(0, 0, 0, 0.5);
    right: 0;
    top: 0;
    bottom: 0;
    ${p => p.animate === true && 'transition: width 2.0s'};
    width: ${p => (p.level > 100 ? 0 : 100 - p.level)}%;
`;

const Label = styled.span`
    width: 70px;
`;

function dbToPercent(db) {
    if (db < -40) {
        return 0;
    }

    const temp = 100 * Math.pow(10, db / 20.0);
    return temp > 110 ? 110 : temp;
}

class Meter extends React.Component {
    state = {
        level: 0,
        db: 'Idle',
        animate: false
    };

    componentDidMount() {}

    componentWillUnmount() {
        if (this._levelTimeout) {
            clearTimeout(this._levelTimeout);
        }

        if (this._dbTimeout) {
            clearTimeout(this._dbTimeout);
        }
    }

    levelAnimate = async () => {
        this._levelTimeout = null;
        this.setState({ level: 0, animate: true });
    };

    levelAnimate2 = async () => {
        this._dbTimeout = null;
        this.setState({ db: -40 });
    };

    trigger(db) {
        db = Math.round(db);
        const level = dbToPercent(db);
        this.setState({ db, level, animate: false });

        if (this._levelTimeout) {
            clearTimeout(this._levelTimeout);
        }
        this._levelTimeout = setTimeout(this.levelAnimate, 100);

        if (this._dbTimeout) {
            clearTimeout(this._dbTimeout);
        }
        this._dbTimeout = setTimeout(this.levelAnimate2, 1500);
    }

    render() {
        const { level, db, animate } = this.state;
        return (
            <Flex alignItems="center">
                <Label>{db <= -40 ? 'Idle' : db + ' dB'}</Label>
                <Frame>
                    <Overlay level={level} animate={animate} />
                </Frame>
            </Flex>
        );
    }
}

export default Meter;



// WEBPACK FOOTER //
// ./src/uic/Meter.js